<form class="p-5" [formGroup]="form">
    <p class="text-lg mb-3">Add Fixer(s)</p>
    <div>
        <div class="grid gap-10">
            <app-autocomplete-fixers
                label="PRIMARY FIXER*"
                variant="secondary"
                description="- The main responsible person for correcting this discrepancy."
                placeholder="Search by contact name, email or distribution list"
                [autoActiveFirstOption]="true"
                [options]="primaryFixerOptions"
                [inputControl]="primaryFixer" />
            <app-chips-autocomplete
                label="ADDITIONAL FIXER(S) (OPTIONAL)"
                [options]="fixerOptions"
                [disabledOptions]="disabledOptions"
                [inputControl]="secondaryFixers"
                [externalSelection]="automationSecondaryFixers"
                (invalidityChange)="invalid = $event" />
        </div>
        <div class="flex justify-end gap-8 mt-5">
            @if (invalid) {
                <small class="color-status-red4">
                    Only drop down selection allowed at this time, please remove
                    any invalid entries in red to continue.
                </small>
            }
            <app-flat-button mat-dialog-close> Cancel </app-flat-button>
            <app-flat-button
                variant="cta"
                [disabled]="saveDisabled || invalid"
                (clicked)="save()">
                OK
            </app-flat-button>
        </div>
    </div>
</form>
